import React from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import ScrollingDialog from '../../components/ScrollingDialog'
import Button from '../../components/Button'
import {
  emptyContentSection,
  hasLearnerGuideContent,
  getSlides,
} from '../../lib'

const StyledList = styled.ul`
  font-size: 1em;
  line-height: 1.75;
`

const Section = ({ title, content }) => (
  <div>
    <h3>{title}</h3>
    {content.length === 0 ? (
      <h6>No incomplete content.</h6>
    ) : (
      <StyledList>
        {content.map((item, i) => <li key={i}>{item}</li>)}
      </StyledList>
    )}
  </div>
)

const SectionTableModal = ({ state: { unit }, history: { goBack } }) => {
  const summPrac =
    unit.summativePracticalAssessments.length > 0
      ? unit.summativePracticalAssessments.reduce((carry, assessment) => {
          if (
            emptyContentSection(assessment.learnerGuideContent) ||
            !assessment.assessmentPlan ||
            (assessment.assessmentPlan &&
              Object.keys(assessment.assessmentPlan).length < 1)
          ) {
            carry.push(assessment.name)
          }
          return carry
        }, [])
      : ['No Summative Practical Assessments have been created.']

  const presentationContent = () => {
    const data = []

    if (getSlides(unit, 'presentation').length === 0) {
      data.push('No PPTX Presentation')
    }

    if (getSlides(unit, 'eLearningPresentation').length === 0) {
      data.push('No eLearning Presentation')
    }

    return data
  }

  return (
    <ScrollingDialog
      title="Incomplete Content"
      actions={[
        <Button key="button" raised primary onClick={goBack}>
          Back
        </Button>,
      ]}>
      <Section
        title="Incomplete Summative Practical Assessments"
        content={summPrac}
      />
      <Section
        title="Incomplete Learner Guide content sections"
        content={hasLearnerGuideContent(unit)}
      />
      <Section title="Presentation Content" content={presentationContent()} />
    </ScrollingDialog>
  )
}

export default injectState(SectionTableModal)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SectionTableModal.js